'use strict';

angular.module('admin.season', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.seasons', {
        url: 'seasons',
        model: 'Season',
        viewOptions: 'seasonViewOptions',
        title: 'Seasons',
        modelNameField: 'name',
        edit: {
            templateUrl: 'admin/season/season.edit.html',
            controller: 'EditCtrl',
            defaults: {
                display_order: 1,
            }
        },
    });
})

.factory('seasonViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    listView
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        queryDefaults: {
            sort: [
                ['id', 'DESC'],
            ],
        },
        list: {
            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    sortable: true,
                },
                {
                    label: 'Name Short',
                    name: 'name_short',
                    sortable: true,
                },
                {
                    label: 'Current',
                    name: 'current',
                    sortable: false,
                },
                {
                    label: 'Enabled',
                    name: 'enabled',
                    sortable: false,
                },
                {
                    label: 'Display Order',
                    name: 'display_order',
                    sortable: true,
                },
            ],
        },
        views: [listView],
    });
});
